module.exports = __webpack_public_path__ + "static/media/html.943e9b3e.png";